// English language pack
export default {
  common: {
    home: 'Home',
    products: 'Products',
    application: 'Application',
    quality: 'Quality',
    about: 'About Us',
    contact: 'Contact Us',
    search: 'Search',
    searchPlaceholder: 'Please enter keyword',
    login: 'Login',
    logout: 'Logout',
    more: 'More',
    viewFile: 'View File',
    downloadFile: 'Download File',
    onlineHelp: 'Download',
    en: 'EN',
    simplifiedChinese: 'Simplified Chinese',
    traditionalChinese: 'Traditional Chinese',
    english: 'English',
    noData: 'No Data',
    loading: 'Loading...',
    noFiles: 'No Files'
  },
  nav: {
    home: 'Home',
    products: 'Products',
    application: 'Applications',
    applicationIndustry: 'Industry Applications',
    applicationManual: 'Product Application Manual',
    quality: 'Quality Management',
    newsCenter: 'News Center',
    companyNews: 'Company News',
    techCategory: 'Tech Sharing',
    about: 'About Us',
    investor: 'Investor Relations',
    contact: 'Contact Us',
    memsSensor: 'MEMS Sensor',
    memsSiliconMicrophone: 'Audio Sensors'
  },
  home: {
    powerProducts: 'Power Products',
    audioProducts: 'Audio Products',
    audioSignalChainChips: 'Audio Signal Chain Chips',
    aboutUs: 'about us',
    coreProducts: 'Core Products',
    coreProductsDesc: 'Industry Leading Products',
    seniorIntroduction: 'Senior Introduction',
    seniorIntroductionDesc: 'Senior Introduction',
    newsInformation: 'News Information',
    newsInformationDesc: 'News Information',
    technicalSharing: 'Technical Sharing',
    technicalSharingDesc: 'Technical Sharing',
    greenEnergy: 'Green Energy',
    communication: 'Communication',
    smartLife: 'Smart Life',
    automotive: 'Automotive',
    computing: 'Computing',
    industry: 'Industry',
    sicMosfet: 'SiC MOSFET',
    automotivePower: 'ATV Power Devices',
    memsMicrophone: 'MEMS Silicon Microphone Sensor Chip',
    sicMosfetDesc1: 'Product performance reaches the top tier in the world',
    sicMosfetDesc2: '8-inch SiC MOS',
    sicMosfetDesc3: 'Large scale shipments of EVs, EV-Chargers, PV-ESS, AIDC power, and industrial sectors',
    sicMosfetDesc4: 'Strategic Support of UNT',
    automotivePowerDesc1: 'Broad power devices(From Si to SiC/GaN)',
    automotivePowerDesc2: 'SiC MOS, IGBT, SJ MOS, LV MOS, FRD,.etc has achieved large-scale shipment among automotive customers',
    automotivePowerDesc3: 'Comprehensive coverage of automotive electric drive system, BMS, Chassis, TMS, BCM,, etc',
    automotivePowerDesc4: 'Core supplier of Multiple top global Tier 1',
    memsMicrophoneDesc1: 'Cumulative shipment exceeds 2 billion pieces, ranking among the top in the world',
    memsMicrophoneDesc2: 'Fully coverage of top brands'
  },
  about: {
    title: 'ALKAIDSEMI',
    slogan: 'Creating an Intelligent and Sustainable Future Together',
    corporateCulture: 'Corporate Culture',
    corporateCultureTitle: 'Corporate<br>Culture',
    corporateCultureDesc: 'Corporate Culture',
    esg: 'ESG',
    companyIntro: 'Company Introduction',
    corporateVideo: 'Corporate Video',
    videoNotSupported: 'Your browser does not support the video tag.',
    vision: {
      title: 'Vision',
      content: 'To become a world-class<br>analog and mixed-signal<br>chip company'
    },
    mission: {
      title: 'Mission',
      content: 'Focus on information and energy<br>to make life better and more<br>efficient'
    },
    values: {
      title: 'Values',
      content: 'Customer: Customer-centric<br>Innovation: Continuous innovation<br>Excellence: Pursuit of excellence<br>Striving: Based on strivers, proud of challengers'
    }
  },
  products: {
    title: 'Products'
  },
  footer: {
    productCenter: 'Product Center',
    productApplication: 'Product Application',
    qualityManagement: 'Quality Management',
    aboutYaoxin: 'About Yaoxin',
    contactUs: 'Contact Us',
    slogan: 'Creating an Intelligent and Sustainable Future Together',
    siliconPower: 'Silicon Power Devices',
    sicPower: 'SiC Power Devices',
    memsSensor: 'MEMS Sensors',
    signalChain: 'Signal Chain Chips',
    automotive: 'Automotive',
    greenEnergy: 'Green Energy',
    communication: 'Communication',
    highPerformanceComputing: 'High Performance Computing',
    industry: 'Industry',
    smartLife: 'Smart Life',
    qualityPolicy: 'Quality Policy',
    qualityCert: 'Quality System Certification',
    totalQuality: 'Total Quality Management',
    contactMethod: 'Contact Method',
    salesNetwork: 'Sales Network',
    feedback: 'Feedback',
    privacyPolicy: 'Privacy Policy',
    copyright: 'Copyright © 2024 Yaoxin Micro (Shanghai) Electronics Technology Co., Ltd.'
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Welcome to contact us',
    returnHome: 'Return to Home',
    leaveMessage: 'Leave Us a Message',
    leaveMessageDesc: 'If you have any questions or suggestions, please fill out the form below to contact us. We will reply to you within 24 hours.',
    form: {
      name: 'Your Name*',
      phone: 'Your Phone Number*',
      company: 'Your Company Name',
      email: 'Your Email',
      message: 'Message*',
      submit: 'Submit Now',
      readAgreement: 'I have read',
      userAgreement: 'User Agreement',
      privacyPolicy: 'Privacy Policy'
    },
    validation: {
      enterName: 'Please enter your name',
      enterPhone: 'Please enter your phone number',
      invalidPhone: 'Invalid phone number',
      enterCompany: 'Please enter your company name',
      enterMessage: 'Please enter your message',
      checkAgreement: 'Please check the user agreement',
      confirmSubmit: 'Confirm to submit message',
      submitSuccess: 'Message submitted successfully, we will contact you soon!',
      submitFailed: 'Submission failed, please try again later.'
    },
    labels: {
      contact: 'Contact: ',
      phone: 'Phone: ',
      email: 'Email: ',
      address: 'Address: '
    },
    cities: {
      shanghai: {
        name: 'Shanghai'
      },
      shenzhen: {
        name: 'Shenzhen'
      },
      xian: {
        name: 'Xi\'an'
      },
      chengdu: {
        name: 'Chengdu'
      }
    }
  },
  investor: {
    download: 'Download',
    noData: 'No Data',
    view: 'View',
    viewDetail: 'View Details',
    viewFile: 'View File',
    disclosure: 'Information Disclosure',
    governanceTitle: 'Corporate Governance',
    stockInfo: 'Stock Information',
    investorLog: 'Investor Log',
    investorContact: 'Investor Relations Contact',
    title: 'Investor Relations',
    subtitle: 'Investor Relations',
    breadcrumbHome: 'Home',
    breadcrumbInvestor: 'Investor Relations',
    query: 'Search',
    meetingRegistration: 'Click to enter meeting registration and webcast',
    pageTitles: {
      disclosure: 'Information Disclosure',
      governance: 'Corporate Governance',
      stockInfo: 'Stock Information',
      investorLog: 'Investor Log',
      investorContact: 'Investor Relations Contact'
    },
    subNav: {
      prospectus: 'Prospectus',
      reports: 'Financial Reports',
      announcements: 'Announcements & Circulars',
      presentations: 'Presentation Materials',
      emails: 'Email Notifications'
    },
    columns: {
      hShares: 'H Shares',
      otherDocuments: 'Other Documents'
    },
    icons: {
      expand: 'Expand',
      collapse: 'Collapse',
      search: 'Search',
      date: 'Date',
      report: 'Report'
    },
    search: {
      placeholder: 'Please enter keywords to search'
    },
    contact: {
      title: 'Investor Relations Contact',
      department: 'Investor Relations Department',
      workingHours: 'Working Hours',
      onlineConsultation: 'Online Consultation',
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        submit: 'Submit'
      },
      address: 'Address',
      email: 'Email',
    },
    governance: {
      companyStructure: 'Company Structure',
      boardCommittees: 'Board Committees',
      directorsSupervisors: 'Directors, Supervisors and Senior Management',
      companyStructureTitle: 'Company Structure',
      companyStructureDesc: 'Company Organization Chart',
      executiveDirectors: 'Executive Director',
      nonExecutiveDirectors: 'Non-executive director',
      independentDirectors: 'Independent Non-Executive Director',
      auditCommittee: 'Audit Committee',
      remunerationCommittee: 'Compensation Committee',
      nominationCommittee: 'Nomination Committee',
      corporateGovernanceCommittee: 'Enterprise Management Committee',
      chairman: 'Chairman',
      governanceDocuments: 'Governance Documents'
    }
  },
  product: {
    downloadMerged: 'Download Merged Document',
    downloadFailed: 'Download Failed',
    selectAtLeastOneDoc: 'Please select at least one document',
    noDataToExport: 'No data to export',
    exportFailed: 'Export Failed',
    returnToList: 'Return to List',
    returnToDirectory: 'Return',
    signalChainChips: 'Signal Chain Chips',
    audioSignalChainChips: 'Audio Signal Chain Chips',
    productCenter: 'Products',
    title: 'Title',
    type: 'Type',
    date: 'Date',
    document: 'Document',
    selectAll: 'Select All',
    productParams: 'Product Parameters',
    technicalDocs: 'Technical Documents',
    clickPartNumber: 'Click part number to view details',
    noCategoryInfo: 'No information in this category',
    select: 'Select',
    reset: 'Reset',
    exportTable: 'Export Selection Table',
    learnMore: 'Learn More',
    selectAtLeastOne: 'Please select at least one product',
    selectAtLeastOneDoc: 'Please select at least one document',
    productsDescription: 'Yaoxin is committed to the design, R&D and sales of power devices, smart sensors and signal chain chips. The main products are full-category power devices (SiC MOS, IGBT, SJ MOS and medium-low voltage MOS), MEMS sensors and signal chain chips.',
    loading: 'Loading...',
    audioSignalChainTitle: 'Audio Signal Chain Chips',
    audioSignalChainDescription: 'Based on our MEMS microphones, we contribute on the most valuable segments of audio signal chain systems, and provide comprehensive audio signal chain solutions.'
  },
  application: {
    application: 'Application',
    diagram: 'Diagram',
    relatedProducts: 'Related Products',
    noApplicationContent: 'No application content',
    noDiagramContent: 'No diagram content',
    noRelatedProducts: 'No related products',
    productApplication: 'Product Application'
  },
  news: {
    returnToList: 'Return to List'
  },
  search: {
    title: 'Search',
    searchTitle: 'Search',
    breadcrumbProducts: 'Products',
    select: 'Select',
    download: 'Download',
    noResults: 'No related products found',
    loading: 'Loading...',
    totalResults: 'Total {total} results found',
    pageSize: 'Page Size',
    prevPage: 'Previous',
    nextPage: 'Next',
    jumpTo: 'Jump to',
    confirm: 'Confirm',
    headers: {
      subject: 'Part Number',
      status: 'Status',
      spiceModel: 'Spice Model',
      package: 'Package',
      cfg: 'Cfg',
      vds: 'VDS(V)',
      vgs: 'Vgs(V)',
      ida: 'ID(A)',
      vth: 'Vth(V)',
      typ10: 'Typ@10V',
      max10v: 'Max@10V',
      typ45: 'Typ@4.5V',
      max45: 'Max@4.5V',
      ciss: 'CISS_Typ(pF)',
      coss: 'COSS_Typ(pF)',
      crss: 'CRSS_Typ(pF)',
      qgnc: 'QG_Typ(nC)',
      pic2: 'Datasheet',
      spice_model: 'Spice Model'
    }
  },
  login: {
    title: 'Yaoxin Microelectronics Staff Login',
    emailOrUsername: 'Email/Username',
    passwordPlaceholder: 'Please enter password',
    captchaPlaceholder: 'Please enter captcha',
    loginButton: 'Login',
    enterUsername: 'Please enter username',
    enterPassword: 'Please enter password',
    enterCaptcha: 'Please enter captcha',
    loginFailed: 'Login failed, please try again later',
    loginError: 'Incorrect username or password!',
    apiNotConfigured: 'Login function requires backend API support, please contact developer to configure login interface'
  },
  senior: {
    guo: {
      name: 'Guo Liangliang',
      position: 'Chairman/General Manager',
      desc: [
        '• National Science and Technology Entrepreneurship Leading Talent',
        '• Former Senior Manager of Technology Development at SMIC, R&D Director of High Voltage Devices and BCD at Huahong NEC',
        '• 18 years of semiconductor technology development experience, mentored by Academician Hao Yue, a leading expert in China\'s third-generation semiconductors'
      ]
    },
    chen: {
      name: 'Chen Kaiyu',
      position: 'Power Product Line Manager',
      desc: [
        '• 21 years of industry experience, former Global MOSFET Business Unit General Manager at Diodes, rich experience in automotive and high-end power device development'
      ]
    },
    wang: {
      name: 'Wang Yiming',
      position: 'IC Product Line Manager',
      desc: [
        '• 18 years of power supply analog chip development and product experience, former Engineering Product Department Manager at MPS'
      ]
    },
    wangqs: {
      name: 'Wang Qingsong',
      position: 'Audio Product Line Manager',
      desc: [
        '• 18 years of audio signal chain IC development and product experience',
        '• Former Technical Director of Chip R&D Center at Allwinner Technology, R&D Manager of Audio Signal Chain for Huawei HiSilicon Kirin Chips'
      ]
    },
    li: {
      name: 'Li Weigang',
      position: 'Operations Manager',
      desc: [
        '• 20 years of industry experience, former Power Device Engineering Manager at Huahong Grace, Sensor R&D Manager at SMIC, familiar with sensor and power device markets, familiar with FAB and OSAT operations management'
      ]
    },
    zheng: {
      name: 'Zheng Zhaoxing',
      position: 'Quality Manager',
      desc: [
        '• 22 years of industry experience, former Process Integration Director at SMIC, Process Integration Department Head at Huali Micro, served top-tier customers, proficient in FAB engineering and mass production management'
      ]
    },
    luo: {
      name: 'Luo Xi',
      position: 'East China/Automotive Sales',
      desc: [
        '• 23 years of industry experience, former Senior Sales Director of Automotive Business Unit at Infineon, responsible for sales and distributor management of all ATV products, proficient in automotive market and OEMs'
      ]
    },
    huang: {
      name: 'Huang Dongyu',
      position: 'South China Sales',
      desc: [
        '• 23 years of industry experience, former Sales Manager of Greater China at IR, Sales Manager of PSS Business Unit at Infineon, familiar with power electronics drives and power device markets'
      ]
    },
    zhu: {
      name: 'Zhu Weiqing',
      position: 'Audio Sales',
      desc: [
        '• 25 years of semiconductor industry experience, former Vice President of Marketing at CECport, Marketing Director of China Region at Arrow, familiar with semiconductor market and customer base'
      ]
    }
  }
}

